import { FaBrands } from '../interfaces/fa-brands.interface';

export const faBrands: FaBrands = {
  whatsapp: 'fa-brands fa-whatsapp'
};
